import type { PlaceEvent, TravelMode } from '../api/types';
import { distance, span } from '../../routes/timeline/format';

const tripNouns: Record<TravelMode, string> = {
  driving: 'a drive',
  walking: 'a walk',
  running: 'a run',
  cycling: 'a bike ride',
  bus: 'a bus ride',
  train: 'a train ride',
  flight: 'a flight',
  other: 'a trip',
};

// tripNoun names a trip by how the member traveled, as alerts do.
export function tripNoun(mode: TravelMode): string {
  return tripNouns[mode] ?? 'a trip';
}

// eventText says what happened, without who: "arrived at School", "left
// Home", or "finished a drive at 412 Oak St: 8.4 mi, 22 min". placeName
// gives the name of a place in the group, or undefined when the reader
// already knows the place.
export function eventText(e: PlaceEvent, placeName?: (id: string) => string | undefined): string {
  const place = e.place_id ? placeName?.(e.place_id) : undefined;
  switch (e.kind) {
    case 'arrive':
      return place ? `arrived at ${place}` : 'arrived';
    case 'depart':
      return place ? `left ${place}` : 'left';
  }
  const t = e.trip!;
  const where = e.place_id ? place : t.address || 'an unknown spot';
  const at = where ? ` at ${where}` : '';
  return `finished ${tripNoun(t.mode)}${at}: ${distance(t.distance_m)}, ${span(t.duration_s)}`;
}

// eventIcon is the Line Awesome icon for an event.
export function eventIcon(e: PlaceEvent): string {
  if (e.kind === 'arrive') return 'la-sign-in-alt';
  if (e.kind === 'depart') return 'la-sign-out-alt';
  return 'la-flag-checkered';
}
